"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dumpTruckColumnFullWidthProps = exports.dumpTruckColumnProps = exports.dumpTruckTypes = void 0;
const constants_1 = require("utils/constants");
exports.dumpTruckTypes = {
    SET_DATA_GRID: 'DUMP TRUCK TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'DUMP TRUCK TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'DUMP TRUCK TYPES ON MUTATION',
    ON_CHANGE_DATAITEM: 'DUMP TRUCK TYPES ON CHANGE DATAITEM',
    ON_SAVE_DATAITEM: 'DUMP TRUCK TYPES ON SAVE DATAITEM',
    GET_DETAIL: 'DUMP TRUCK TYPES ON GET DETAIL',
    ON_FILTER_CHANGE: 'DUMP TRUCK TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE: 'DUMP TRUCK TYPES ON SORT CHANGE',
    ON_DELETE: 'DUMP TRUCK TYPES ON DELETE',
    SET_ERROR: 'DUMP TRUCK TYPES REDUCER SET ERROR',
};
exports.dumpTruckColumnProps = [
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '400px',
        filter: 'text'
    },
    {
        show: true,
        field: 'dumptruck_no',
        title: 'DT No',
        width: '150px',
        filter: 'text'
    },
    {
        show: true,
        field: 'capacity_volume',
        title: 'Volume Capacity',
        width: '175px',
        filter: 'numeric',
    },
    {
        show: true,
        field: 'dumptruck_spec',
        title: 'Dump Truck Spec',
        width: '175px',
        filter: 'text',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean'
    },
];
exports.dumpTruckColumnFullWidthProps = [
    ...exports.dumpTruckColumnProps
];
exports.dumpTruckColumnFullWidthProps[0] = {
    show: true,
    field: 'contractor_name',
    title: 'Contractor',
    width: 'auto',
    filter: 'text'
};
